import { gql } from '@apollo/client'

export const SIDEBAR_QUERY = gql`
  query Sidebar {
    allIssues(closedAt_Isnull: true, archivedAt_Isnull: true) {
      total
    }
  }
`
